module.exports = __webpack_public_path__ + "static/media/linkedin-new.899c6b62.svg";